import React from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';

export default function MobileProductsLayout({ children }) {
  return (
    <div className='container mp-shell'>
      <div className='row'>
        <div className='col p-0'>
          <Header />
        </div>
      </div>
      {children}
      <div className='row'>
        <div className='col p-0'>
          <Footer />
        </div>
      </div>
    </div>
  );
}
